import { useMutation, useQueryClient } from "@tanstack/react-query";
import qcareApi from "./qcareApi";
import { PDFLink } from "../components/ui/ModalSendPDF";


interface MailProps {
    mailTo: string
    cc: string
    subject: string
    message: string
    link: string
    signature: boolean
    reportId: string
}

interface CreatePDF {
    pdf: File
    reportId: string
}

const sendEmail = async (body: MailProps) => {
    const { data } = await qcareApi.post('/pdf/send-mail', body);
    return data
}

const createLink = async (fetchData: PDFLink) => {
    const { data } = await qcareApi.post('/pdf/create-pdf', fetchData)
    return data
}

const createPDF = async ({ pdf, reportId }: CreatePDF) => {

    const formData = new FormData();
    formData.append('reportId', reportId)
    formData.append('pdf-file', pdf)

    const { data } = await qcareApi.post(`/report/create-pdf/${reportId}`, formData)
    return data
}

// ------------------------- HOOKS -------------------------

export const useSendEmail = () => {
    const queryClient = useQueryClient()
    return useMutation(sendEmail, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['reports'])
        }
    })
}

export const useCreateLink = () => {
    return useMutation(createLink)
}

export const useCreatePDF = () => {
    const queryClient = useQueryClient()
    return useMutation(createPDF, {
        onSuccess: async (data) => {
            await queryClient.invalidateQueries(['report', data.reportId])
        }
    })
}

